module.exports = __webpack_public_path__ + "img/left_5.f1fa11df.jpg";